import { AxiosRequestConfig } from "axios";

import { useApi } from "../useApi/useApi";
import { General } from "../../models/General";

/**
 * Fetch hook for authorization code label
 */
export const useGetGeneral = () => {
  const req: AxiosRequestConfig = {
    url: "/api/general",
    method: "get",
    headers: { "Content-Type": "application/json" },
  };
  const { state } = useApi<General>(req);
  return state;
};
